import React from 'react'
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

export default function WeddingTab() {
  return (
    <>
     <section className="wedd-logotab">
        <div className="container">
            <div className="row justify-content-center"> 

                <div className="col-lg-10 col-md-10"> 
                    <Tab.Container defaultActiveKey="logo-tab1">
                        <Tab.Content className="logotab-content">
                            <Tab.Pane eventKey="logo-tab1">
                                <p>“Recognised by Forbes, Sonam Label represents the business of refined Indian couture. Built on disciplined craftsmanship and bespoke artistry, the brand seamlessly blends heritage bridal techniques with contemporary design, positioning Indian luxury as a globally relevant, high-value enterprise.”</p>
                            </Tab.Pane>

                            <Tab.Pane eventKey="logo-tab2">
                                <p>“As featured in Vogue, Sonam Label reimagines Indian couture with quiet opulence and emotional storytelling. Every creation reflects meticulous handwork and personalised detail, transforming bridal traditions into modern heirlooms defined by elegance, individuality, and grace.”</p>
                            </Tab.Pane>

                            <Tab.Pane eventKey="logo-tab3">
                                <p>“Spotlighted by ELLE, Sonam Label celebrates modern Indian femininity through couture that feels both intimate and expressive. Rooted in artisanal excellence and personalised craftsmanship, the brand brings a fresh, confident sensibility to timeless bridal narratives.”</p>
                            </Tab.Pane>

                            <Tab.Pane eventKey="logo-tab4">
                                <p>“Featured in Business of Fashion, Sonam Label exemplifies the evolution of Indian couture into a globally conscious luxury brand. With a focus on craftsmanship, customisation, and design integrity, the label bridges tradition and modernity through a strategically refined couture practice.”</p>
                            </Tab.Pane>
                        </Tab.Content>

                        <Nav className="logotab-link">
                            <Nav.Item>
                                <Nav.Link eventKey="logo-tab1"> <img src="/image/tablogo-1.webp" alt="logo" loading="lazy"/> </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="logo-tab2"> <img src="/image/tablogo-2.webp" alt="logo" loading="lazy"/> </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="logo-tab3"> <img src="/image/tablogo-3.webp" alt="logo" loading="lazy"/> </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="logo-tab4"> <img src="/image/tablogo-4.webp" alt="logo" loading="lazy"/> </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </Tab.Container>
                </div>

            </div> 
        </div>
    </section>
    </>
  )
}
